module.exports = __webpack_public_path__ + "img/add-user.fa611c78.svg";